import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var Payment = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor"
  };
  return React.createElement(StyledIconBase, tslib_1.__assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z",
    key: "k0"
  }));
});
Payment.displayName = 'Payment';
export var PaymentDimensions = {
  height: 24,
  width: 24
};